<template>
  <div :class="clsx(['accordion-triangle', { open: props.open }])">
    <svg
      :width="props.size"
      :height="props.size"
      :viewBox="`0 0 ${props.size} ${props.size}`"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_963_5)">
        <path
          d="M11.5388 9.11912C11.5388 9.36991 11.4943 9.61024 11.4055 9.84013C11.3166 10.07 11.1907 10.2712 11.0276 10.4435C10.8646 10.616 10.6745 10.7492 10.4571 10.8433C10.2398 10.9373 10.0076 10.9895 9.76062 11H2.23294C1.89706 10.9791 1.59576 10.8876 1.32902 10.7257C1.06229 10.5637 0.84496 10.326 0.67702 10.0125C0.528837 9.70951 0.457214 9.39081 0.462153 9.05643C0.467092 8.72205 0.558473 8.40335 0.736292 8.10031L4.50014 1.87774C4.66808 1.60606 4.88048 1.39185 5.13733 1.23511C5.39418 1.07837 5.67819 1 5.98938 1C6.30057 1 6.59199 1.08098 6.86366 1.24295C7.13533 1.40491 7.34525 1.61651 7.49344 1.87774L11.2573 8.10031C11.445 8.39289 11.5388 8.7325 11.5388 9.11912Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_963_5">
          <rect
            :width="props.size"
            :height="Math.round(props.size * (10 / 12))"
            fill="currentColor"
            transform="translate(0 1)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script lang="ts" setup>
import clsx from 'clsx';

const props = withDefaults(defineProps<{ color?: string; size?: number; open: boolean }>(), {
  color: undefined,
  size: 12,
  open: false
});
</script>

<style scoped>
.accordion-triangle {
  display: flex;
  align-items: center;
  width: 14px;
  height: 14px;
  color: inherit;
  transform: translateY(2px);
  transition: transform 0.3s ease;

  &.open {
    transform: rotate(180deg) translateY(-2px);
  }
}
</style>
